<template>
  <v-container fluid>
    <AppConfirma :dialogs="dialogs" @resposta="getResposta" />
    <AppBar titulo="Agenda" destino="alunos" />
    <AppAlerta :snack="snack" />
    <v-row align="center" justify="center">
      <v-col col="12" md="12" xl="12" xs="12" sm="12">
        <v-card>
          <ValidationObserver ref="form" #default="{ handleSubmit }">
            <v-form @keyup.enter="handleSubmit(salvar)" @submit.prevent="handleSubmit(salvar)">
              <v-card-text>
                <v-row>
                  <v-col col="6" md="6" xl="6">
                    <v-text-field v-model="nome" label="Aluno" color="#FF562B" outlined disabled>
                    </v-text-field>
                  </v-col>
                  <v-col col="6" md="6" xl="6">
                    <v-text-field
                      v-model="treinador"
                      label="Treinador"
                      color="#FF562B"
                      outlined
                      disabled
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col col="6" md="6" xl="6">
                    <ValidationProvider
                      #default="{ errors }"
                      :rules="{ required: true }"
                      name="dia da semana"
                    >
                      <v-select
                        v-model="diasemana"
                        :items="dias"
                        label="Dia da semana"
                        color="#FF562B"
                        :error-messages="errors[0]"
                        outlined
                      >
                      </v-select>
                    </ValidationProvider>
                  </v-col>
                  <v-col col="6" md="6" xl="6">
                    <ValidationProvider
                      #default="{ errors }"
                      :rules="{ required: true }"
                      name="hora"
                      v-mask="'##:##'"
                    >
                      <v-text-field
                        v-model="hora"
                        label="Hora"
                        color="#FF562B"
                        :error-messages="errors[0]"
                        outlined
                      >
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider />
              <v-card-actions>
                <v-row>
                  <v-col col="4" md="4" xl="4">
                    <v-btn
                      :disabled="SalvarDesativado"
                      color="#FF562B"
                      width="100%"
                      type="submit"
                      dark
                      >Salvar</v-btn
                    >
                  </v-col>
                  <v-col col="4" md="4" xl="4">
                    <v-btn color="red" width="100%" dark @click="excluir()" :disabled="isDisabled"
                      >Excluir</v-btn
                    >
                  </v-col>
                  <v-col col="4" md="4" xl="4">
                    <v-btn @click="cancelar()" color="grey" width="100%" dark>Cancelar</v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </v-card>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col col="12" md="12" xl="12" xs="12" sm="12">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="agendas"
            :items-per-page="10"
            class="elevation-1"
          >
            <template v-slot:[`item.dia`]="{ item }">
              <span>
                {{ getDiaSemana(item.dia_semana) }}
              </span>
            </template>
            <template v-slot:[`item.hora`]="{ item }">
              <span>
                {{ formataHora(item.horario) }}
              </span>
            </template>
            <template v-slot:[`item.editar`]="{ item }">
              <v-icon medium class="mr-2" @click="editarAgenda(item)"> mdi-pencil-outline </v-icon>
            </template>
            <!-- <template v-slot:[`item.excluir`]="{ item }">
                            <v-icon
                            medium
                            style="align: center"
                            @click="excluirContrato(item.id)"
                            >
                            mdi-trash-can-outline
                            </v-icon>
                        </template>             -->
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import AppBar from '../../components/AppBar.vue';
import AppConfirma from '../../components/AppConfirma.vue';
import AppAlerta from '../../components/AppAlerta.vue';
import _aluno from '../../services/aluno/aluno-servico.js';
import _agenda from '../../services/aluno/aluno-agenda-servico.js';
import _utils from '../../utils/utils.js';

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    AppBar,
    AppConfirma,
    AppAlerta,
  },
  data() {
    return {
      dialogs: {
        dialog: false,
        titulo: '',
      },
      snack: {
        snackbar: false,
        texto: '',
        cor: '',
      },
      id: 0,
      aluno: [],
      agendas: [],
      nome: '',
      treinador: '',
      diasemana: '',
      hora: '',
      isDisabled: true,
      SalvarDesativado: true,
      dias: [
        { text: 'Segunda', value: 1 },
        { text: 'Terça', value: 2 },
        { text: 'Quarta', value: 3 },
        { text: 'Quinta', value: 4 },
        { text: 'Sexta', value: 5 },
        { text: 'Sábado', value: 6 },
        { text: 'Domingo', value: 7 },
      ],
      headers: [
        { text: 'Código', value: 'id' },
        { text: 'Dia da Semana', align: 'start', value: 'dia' },
        { text: 'Hora', value: 'hora' },
        { text: 'Editar', value: 'editar', align: 'center', sortable: false },
      ],
    };
  },

  mounted() {
    if (this.$route.params.aluno != null) {
      this.aluno = this.$route.params.aluno;
      this.nome = this.aluno.nome;
      this.treinador = this.aluno.treinador;
      this.listarAgenda(this.aluno.id);
      if (this.id == 0) {
        this.SalvarDesativado = false;
      }
    } else {
      this.$router.push({ name: 'alunos' });
    }
  },

  methods: {
    buscar(id) {
      _aluno.buscarAluno(id).then(response => {
        this.aluno = response;
        this.nome = this.aluno.nome;
        this.treinador = this.aluno.treinador_id;
      });
    },
    listarAgenda(id) {
      _agenda.buscarAgenda(id).then(response => {
        console.log(response);
        this.agendas = response;
      });
    },
    salvar() {
      this.agenda = {
        aluno_id: this.aluno.id,
        dia_semana: this.diasemana,
        horario: this.hora,
        treinador_id: this.aluno.treinador_id,
      };

      if (this.id == 0) {
        this.salvarAgenda();
      } else {
        this.atualizar();
      }
    },
    salvarAgenda() {
      _agenda
        .salvarAgenda(this.agenda)
        .then(() => {
          this.snack.texto = 'Agenda salva com sucesso!';
          this.snack.snackbar = true;
          setTimeout(() => {
            this.listarAgenda(this.aluno.id);
          }, 500);
          this.limparCampos();
        })
        .catch(() => {
          this.dialogs.dialog = false;
          this.snack.snackbar = true;
          this.snack.texto = 'Erro ao salvar agenda!';
          this.snack.cor = 'error';
        });
    },
    atualizar() {
      _agenda
        .atualizarAgenda(this.id, this.agenda)
        .then(() => {
          this.dialogs.dialog = false;
          this.snack.snackbar = true;
          this.snack.texto = 'Agenda atualizada com sucesso!';
          this.snack.cor = 'success';
          setTimeout(() => {
            this.listarAgenda(this.aluno.id);
          }, 500);
        })
        .catch(() => {
          this.dialogs.dialog = false;
          this.snack.snackbar = true;
          this.snack.texto = 'Erro ao atualizar agenda!';
          this.snack.cor = 'error';
        });
    },
    editarAgenda(agenda) {
      this.id = agenda.id;
      this.diasemana = agenda.dia_semana;
      this.hora = agenda.horario;
      // verificar se não tem aulas para habilitar o excluir
      this.isDisabled = false;
    },
    excluir() {
      this.dialogs.dialog = true;
      this.dialogs.titulo = 'Excluir Agenda';
      this.dialogs.mensagem = 'Deseja realmente excluir a agenda?';
    },
    getResposta(resposta) {
      if (resposta) {
        _agenda
          .excluirAgenda(this.id)
          .then(() => {
            this.dialogs.dialog = false;
            this.snack.snackbar = true;
            this.snack.texto = 'Agenda excluída com sucesso!';
            this.snack.cor = 'success';
            this.listarAgenda(this.aluno.id);
          })
          .catch(() => {
            this.dialogs.dialog = false;
            this.snack.snackbar = true;
            this.snack.texto = 'Erro ao excluir agenda!';
            this.snack.cor = 'error';
          });
      } else {
        this.dialogs.dialog = false;
      }
    },
    getDiaSemana(dia) {
      return _utils.diaSemana(dia);
    },
    formataHora(hora) {
      return _utils.formataHora(hora);
    },
    limparCampos() {
      this.id = 0;
      this.diasemana = '';
      this.hora = '';
      this.$refs.form.reset();
    },
    cancelar() {
      this.rota('alunos');
    },
    rota(rota) {
      this.$router.replace({ name: rota });
    },
  },
};
</script>
